"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _hooks = require("../../utils/hooks");

var _DesktopNav = _interopRequireDefault(require("./DesktopNav"));

var _MobileNav = _interopRequireDefault(require("./MobileNav"));

var _Nav = require("./Nav.style");

var Nav = function Nav(_ref) {
  var account = _ref.account,
      actions = _ref.actions,
      activePath = _ref.activePath,
      breakpoint = _ref.breakpoint,
      homeLink = _ref.homeLink,
      logoImage = _ref.logoImage,
      primaryLinks = _ref.primaryLinks,
      secondaryLinks = _ref.secondaryLinks,
      accessibility = _ref.accessibility,
      rest = _objectWithoutProperties(_ref, ["account", "actions", "activePath", "breakpoint", "homeLink", "logoImage", "primaryLinks", "secondaryLinks", "accessibility"]);

  var _ref2 = (0, _emotionTheming.useTheme)(),
      breakpoints = _ref2.breakpoints;

  var windowWidth = (0, _hooks.useWindowWidth)();
  var isMobile = windowWidth <= parseInt(breakpoints[breakpoint], 10);
  var desktopNavProps = {
    account: account,
    actions: actions,
    activePath: activePath,
    homeLink: homeLink,
    logoImage: logoImage,
    primaryLinks: primaryLinks,
    secondaryLinks: secondaryLinks,
    accessibility: accessibility
  };
  var mobileNavProps = {
    actions: actions,
    account: account,
    homeLink: homeLink,
    logoImage: logoImage,
    primaryLinks: primaryLinks,
    secondaryLinks: secondaryLinks,
    accessibility: accessibility
  };
  return /*#__PURE__*/_react.default.createElement(_Nav.Wrapper, rest, isMobile ? /*#__PURE__*/_react.default.createElement(_MobileNav.default, mobileNavProps) : /*#__PURE__*/_react.default.createElement(_DesktopNav.default, desktopNavProps));
};

Nav.propTypes = {
  /** Object defining account area, avatar property is used to control display of the avatar circle, either with image or name, menu is the array of items supplied to the dropdown menu */
  account: _propTypes.default.shape({
    avatar: _propTypes.default.shape({
      image: _propTypes.default.shape({
        /** Fluid image object */
        fluid: _propTypes.default.shape({
          base64: _propTypes.default.string.isRequired,
          aspectRatio: _propTypes.default.number.isRequired,
          src: _propTypes.default.string.isRequired,
          srcSet: _propTypes.default.string.isRequired,
          srcSetWebp: _propTypes.default.string.isRequired,
          sizes: _propTypes.default.string.isRequired
        }),

        /** File src of image object in case we dont have a fluid obj */
        src: _propTypes.default.string
      }),
      name: _propTypes.default.string
    }),
    menu: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string,
      onClick: _propTypes.default.func,
      url: _propTypes.default.string
    }))
  }),

  /** Array of objects defining Call to Actions (Buttons) */
  actions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    onClick: _propTypes.default.func,
    url: _propTypes.default.string
  })),

  /** Pathname of the active item, used to determine the the active item, if not specified or there is no match with any of the nav links, no item wil be marked as active */
  activePath: _propTypes.default.string,

  /** Breakpoint used to switch between mobile and desktop UX */
  breakpoint: _propTypes.default.string,

  /** Home address of the page, this typically be '/' */
  homeLink: _propTypes.default.string,

  /** Image object allowing to replace the theme logo with a custom one */
  logoImage: _propTypes.default.shape({
    /** Fluid image object */
    fluid: _propTypes.default.shape({
      base64: _propTypes.default.string.isRequired,
      aspectRatio: _propTypes.default.number.isRequired,
      src: _propTypes.default.string.isRequired,
      srcSet: _propTypes.default.string.isRequired,
      srcSetWebp: _propTypes.default.string.isRequired,
      sizes: _propTypes.default.string.isRequired
    }),

    /** File src of image object in case we dont have a fluid obj */
    src: _propTypes.default.string
  }),

  /** Array of objects defining Primary Nav Menu. onClick callback is optional but useful for implementing things like tracking */
  primaryLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    onClick: _propTypes.default.func,
    url: _propTypes.default.string,
    navItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      description: _propTypes.default.string,
      label: _propTypes.default.string,
      url: _propTypes.default.string,
      onClick: _propTypes.default.func
    }))
  })),

  /** Array of objects defining Secondary Nav Menu (Actions Menu). onClick callback is optional but useful for implementing things like tracking */
  secondaryLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    onClick: _propTypes.default.func,
    url: _propTypes.default.string,
    navItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      description: _propTypes.default.string,
      label: _propTypes.default.string,
      url: _propTypes.default.string,
      onClick: _propTypes.default.func
    }))
  })),
  accessibility: _propTypes.default.shape({
    /** Accessibility label for the primary menu */
    primaryMenuLabel: _propTypes.default.string.isRequired,

    /** Accessibility label for the secondary menu */
    secondaryMenuLabel: _propTypes.default.string.isRequired,

    /** Accessibility label for the user menu */
    userMenuLabel: _propTypes.default.string.isRequired
  })
};
Nav.defaultProps = {
  account: null,
  actions: [],
  activePath: '',
  breakpoint: 'large',
  homeLink: '/',
  logoImage: null,
  primaryLinks: [],
  secondaryLinks: [],
  accessibility: {
    userMenuLabel: 'Account Navigation',
    primaryMenuLabel: 'Primary Navigation',
    secondaryMenuLabel: 'Secondary Navigation'
  }
};
var _default = Nav;
exports.default = _default;